import { memo } from 'react';

import { FooterNavGroupTitle } from './FooterNavGroupTitle';

export * from './FooterNavGroupTitle';

export default memo(FooterNavGroupTitle);
